const SEO = [
	{
		page: "home",
		description:
			"Ankit Singh Yadav is a Backend Systems Engineer and DevOps practitioner specializing in Node.js, scalable APIs, cloud infrastructure, and automation. Experienced with AWS, containerization, and production-grade backend systems.",
		keywords: [
			"Ankit Singh Yadav",
			"Ankit S Yadav",
			"Backend Systems Engineer",
			"Node.js Developer",
			"DevOps Engineer",
			"AWS Backend Developer",
			"Cloud Engineer",
			"Docker",
			"Kubernetes",
		],
	},

	{
		page: "about",
		description:
			"Backend Systems Engineer with hands-on DevOps experience across AWS infrastructure including EC2, ECS, Fargate, VPC, Docker, Kubernetes, Terraform, and Linux. Focused on building secure, scalable, and reliable backend systems.",
		keywords: [
			"Ankit Singh Yadav",
			"Backend Engineer",
			"DevOps Practitioner",
			"AWS EC2",
			"AWS ECS",
			"AWS Fargate",
			"Terraform",
			"Docker",
			"Kubernetes",
			"Linux",
			"System Architecture",
		],
	},

	{
		page: "projects",
		description:
			"Collection of backend and DevOps projects involving Node.js APIs, WhatsApp automation, fintech integrations, cloud deployments, containerized services, and infrastructure automation.",
		keywords: [
			"Node.js Projects",
			"DevOps Projects",
			"AWS Projects",
			"Dockerized Applications",
			"Kubernetes Deployments",
			"Terraform Infrastructure",
			"Backend Systems",
		],
	},

	{
		page: "contact",
		description:
			"Contact Ankit Singh Yadav for backend engineering, DevOps consulting, cloud architecture, or collaboration on scalable software and infrastructure solutions.",
		keywords: [
			"Contact Ankit Singh Yadav",
			"Backend Engineer",
			"DevOps Consultant",
			"AWS Consultant",
			"Cloud Architecture",
			"Node.js Consulting",
		],
	},
];

export default SEO;
